import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { Sprint } from '../types.tsx';

export const getSprint = async (sprintId: string): Promise<Sprint> =>
	fetchJson(`/rest/agile/1.0/sprint/${sprintId}`);
